// Canonical Amplitude event registry for the Service Work Orders surface.
// Event names are silent contracts with Amplitude dashboards: a typo creates a
// junk event rather than throwing, so always import from here instead of
// inlining strings.

// WORK ORDER LIST
export const LIST_PAGE_VIEWED = "work_orders:list_page_viewed"
export const LIST_SEARCHED = "work_orders:list:searched"
export const LIST_STATUS_FILTER_CHANGED =
  "work_orders:list:status_filter_changed"
export const LIST_SCHEDULED_FILTER_CHANGED =
  "work_orders:list:scheduled_filter_changed"

// WORK ORDER CREATE
export const CREATE_MODAL_OPENED = "work_orders:create_modal_opened"
export const CREATED = "work_orders:created"
export const CREATE_DISCARDED = "work_orders:create_work_order:discarded"

// WORK ORDER DETAIL
export const DETAIL_PAGE_VIEWED = "work_orders:detail_page_viewed"

// WORK ORDER ACTIONS (close / reopen). The mutation hook interpolates
// `${prefix}:confirmed|save_failed|discarded` from these prefixes.
export const CLOSE_WORK_ORDER_CLICKED = "work_orders:close_work_order:clicked"
export const REOPEN_WORK_ORDER_CLICKED = "work_orders:reopen_work_order:clicked"
export const CLOSE_WORK_ORDER_PREFIX = "work_orders:close_work_order"
export const REOPEN_WORK_ORDER_PREFIX = "work_orders:reopen_work_order"

// ADD JOB
export const ADD_JOB_MODAL_OPENED = "work_orders:add_job_modal_opened"
export const ADD_JOB_TEMPLATE_CHANGED = "work_orders:add_job:template_changed"
export const ADD_JOB_TEMPLATE_SELECTED = "work_orders:add_job:template_selected"
export const ADD_JOB_FROM_SCRATCH_CLICKED =
  "work_orders:add_job:from_scratch_clicked"
export const CREATE_JOB_DISCARDED = "work_orders:create_job:discarded"

// JOB
export const JOB_CREATED = "work_orders:job_created"
export const JOB_STATUS_TRANSITIONED = "work_orders:job_status_transitioned"

// LINE ITEMS
export const EDIT_LINE_ITEM_OPENED = "work_orders:edit_line_item:opened"
export const REMOVE_INVOICED_LINE_ITEM_OPENED =
  "work_orders:remove_invoiced_line_item:opened"
export const REMOVE_INVOICED_LINE_ITEM_CONFIRMED =
  "work_orders:remove_invoiced_line_item:confirmed"
export const EDIT_LINE_ITEM_DISCARDED = "work_orders:edit_line_item:discarded"
export const EDIT_LINE_ITEM_SAVED = "work_orders:edit_line_item:saved"
export const EDIT_LINE_ITEM_SAVE_FAILED =
  "work_orders:edit_line_item:save_failed"
export const DELETE_LINE_ITEM_CONFIRMED =
  "work_orders:delete_line_item:confirmed"
export const ADD_LINE_ITEM_PRODUCT_SEARCH =
  "work_orders:add_line_item:product_search"
export const ADD_LINE_ITEM_PRODUCT_SELECTED =
  "work_orders:add_line_item:product_selected"
export const ADD_NOTE_SAVED = "work_orders:add_note:saved"
export const ADD_NOTE_SAVE_FAILED = "work_orders:add_note:save_failed"

// EDIT JOB
export const EDIT_JOB_DISCARDED = "work_orders:edit_job:discarded"

// INVOICE MANAGEMENT (WorkOrderPayments)
export const MANAGE_INVOICE_OPENED = "work_orders:manage_invoice:opened"
export const SETTLE_INVOICE_OPENED = "work_orders:settle_invoice:opened"
export const INVOICE_AUTOPAY_SAVED = "work_orders:invoice_autopay:saved"
export const INVOICE_AUTOPAY_SAVE_FAILED =
  "work_orders:invoice_autopay:save_failed"
export const MERGE_INVOICE_OPENED = "work_orders:merge_invoice:opened"
export const REVERSE_INVOICE_OPENED = "work_orders:reverse_invoice:opened"

// GENERATE INVOICE (renamed/replaced in Phase 3)
export const GENERATE_INVOICE_MODAL_OPENED =
  "work_orders:generate_invoice_modal_opened"
export const GENERATE_INVOICE_STEP_VIEWED =
  "work_orders:generate_invoice_step_viewed"
export const GENERATE_INVOICE_STEP_LABELS = {
  select: "select_jobs",
  details: "billing_details",
  review: "review_and_send",
}
export const GENERATE_INVOICE_SUBMITTED =
  "work_orders:generate_invoice_submitted"
export const GENERATE_INVOICE_SAVE_FAILED =
  "work_orders:generate_invoice:save_failed"
export const GENERATE_INVOICE_DISCARDED =
  "work_orders:generate_invoice:discarded"

const CENTS_PER_DOLLAR = 100

// Coarse, governance-approved buckets. We never send raw dollar amounts to
// Amplitude; only these ranges leave the system.
export const bucketAmount = (amountMinorUnits) => {
  const dollars = (amountMinorUnits || 0) / CENTS_PER_DOLLAR
  if (dollars < 500) return "<500"
  if (dollars < 2000) return "500_2k"
  if (dollars < 5000) return "2k_5k"
  return "5k+"
}
